export const   fetchedBadges= 'FETCHED_BADGES'
export const   fetchingBadges= 'FETCHING_BADGES'
export const   errorBadges= 'ERROR_BADGES'
